// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__199W3","bigColWidth":"Table_bigColWidth__3Kee3","biggerColWidth":"Table_biggerColWidth__1ODhr","row":"Table_row__3Ssn4","col":"Table_col__2GFIG"};